import { useHistory } from "react-router-dom";
import { post,get } from 'helpers/api_helper';

export function useRegister() {
  const history = useHistory(); // Use history for navigation

  const register = async (name,email, password) => {
    try {
      await get('/sanctum/csrf-cookie');  
      const data = await post('/api/register', {
        name,
        email,
        password
      });
      if (data.token && data.user) {
        localStorage.setItem('authUser', JSON.stringify(data.user));
        localStorage.setItem('token', data.token);
        history.push("/join_space"); // Redirect to /join_space
      } 
    
      else {
        throw new Error("Registration failed"); 
      }
    } catch (error) {
       return
    }
  };

  return { register };
}